<rt-dropdown
  (click)="$event.preventDefault()"
  class="visibility-dropdown"
  [width]="DropdownWidth.Large"
>
  <rt-dropdown-header>
    <ng-container ngProjectAs="[prefix]">
      <ng-content select="[header-prefix]" />
    </ng-container>
    {{ 'app.visibility.visibility_options' | translate }}
  </rt-dropdown-header>
  <rt-dropdown-item
    [isSelected]="visibility.level === VisibilityLevel.Public"
    (click)="changeVisibilityLevel.emit(VisibilityLevel.Public); toggleDropdown.emit()"
  >
    <rt-icon prefix name="remove-red-eye" />
    <rt-heading variant="heading block">{{ labels!.header.public }} </rt-heading>
    <div class="info-dropdown-text">
      {{ labels!.subheader.public }}
    </div>
  </rt-dropdown-item>
  <rt-feature-guard-dropdown-item
    [mode]="FeatureGuardMode.Dialog"
    [feature]="GuardedFeature.Visibility"
    [useOriginalTemplate]="true"
  >
    @if (hasSelectTeamMembers) {
      <rt-dropdown-item
        [isSelected]="visibility.level === VisibilityLevel.Protected"
        (click)="changeVisibilityLevel.emit(VisibilityLevel.Protected); toggleDropdown.emit()"
      >
        <rt-icon prefix name="account-group" />
        <rt-heading variant="heading block">{{ labels!.header.protected }} </rt-heading>
        <div class="info-dropdown-text">
          {{ labels!.subheader.protected }}
        </div>
      </rt-dropdown-item>
    }
  </rt-feature-guard-dropdown-item>
  @if (hasOnlyMeLevel) {
    <rt-dropdown-item
      [isSelected]="visibility.level === VisibilityLevel.Private"
      (click)="changeVisibilityLevel.emit(VisibilityLevel.Private); toggleDropdown.emit()"
    >
      <rt-icon prefix name="lock" />
      <rt-heading variant="heading block">{{ labels!.header.private }} </rt-heading>
      <div class="info-dropdown-text">
        {{ labels!.subheader.private }}
      </div>
    </rt-dropdown-item>
  }
</rt-dropdown>
